import { CustomButton } from "../../components/customButton/CustomButton";
import CustomRadioButton from "../../components/customRadioButton/CustomRadioButton";
import { BlackClear } from "../../resources/assetsManager";
import { SIDEBAR_COLOR, WHITE_COLOR } from "../../resources/colorsManager";

const GenerateKeyModal = ({ closeModal }) => {
  const RadioData = [
    {
      value: "1",
      label: "Deactivate old key immediately",
    },
    {
      value: "2",
      label: "Deactivate old key in 24 Hours",
    },
  ];
  return (
    <div
      style={{
        width: "30%",
        minWidth: "400px",
        backgroundColor: WHITE_COLOR,
        padding: "20px 30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        borderRadius: "30px",
        position: "relative",
      }}
    >
      <p
        style={{
          color: "black",
          fontSize: "22px",
          margin: "10px 0px 30px 0px",
        }}
        className="roboto"
      >
        {" "}
        Generate Key
      </p>

      <div
        style={{
          backgroundColor: "#E5E5E5",
          width: "36px",
          height: "36px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          right: "30px",
          top: "25px",
          borderRadius: "8px",
          cursor: "pointer",
        }}
        onClick={() => {
          closeModal();
        }}
      >
        <img src={BlackClear} alt="Clear" />
      </div>

      <div style={{ width: "100%" }}>
        <p style={{ color: "black", fontSize: "16px" }}>
          Download details for future reference
        </p>

        <CustomRadioButton data={RadioData} passSelectedValue={(data) => {}} />
      </div>

      <CustomButton
        onClick={() => {}}
        title="OK"
        styles={{
          backgroundColor: SIDEBAR_COLOR,
          border: "0px solid",
          borderRadius: "3px",
          width: "100%",
          height: "50px",
          marginTop: "15px",
          marginBottom: "15px",
        }}
      />
    </div>
  );
};

export default GenerateKeyModal;
